import React from 'react';
import { SanityImage } from 'components';
import { Link } from 'gatsby';
import { useLocation } from '@reach/router';
import styled, { keyframes } from 'styled-components';

function Card({ id, slug, title, image, imageWidth, imageHeight, alt }) {
  const { pathname } = useLocation();
  const basePath = pathname.slice(0, pathname.indexOf('/', 2) + 1);

  return (
    <StyledLink to={`${basePath}${slug}`}>
      {image?.asset ? (
        <SanityImage
          key={image.asset._id}
          title={title}
          image={image}
          width={imageWidth}
          height={imageHeight}
          alt={alt}
        />
      ) : (
        <PlaceholderImage>
          <span>No Image Available</span>
        </PlaceholderImage>
      )}
      <Text>
        <ProductTitle id={id}>
          {title
            .split(' ')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ')}
        </ProductTitle>
        <p>View Product</p>
      </Text>
    </StyledLink>
  );
}

const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

const StyledLink = styled(Link)`
  animation: ${fadeIn} 0.2s ease-in-out forwards;
  background-color: #fff;
  border: 0.063rem solid #c4c4c4;
  border-radius: 0.375rem;
  display: grid;
  gap: 0;
  grid-row: span 3;
  grid-template-rows: subgrid;
  height: 100%;
  opacity: 0;
  overflow: hidden;
  text-decoration: none;
  width: 100%;

  @media (width >= 48rem) {
    grid-column: span 3;
  }

  &:hover {
    box-shadow: 0.188rem 0.188rem 0.438rem rgb(189 189 189 / 40%);
    transform: translate3d(0, -0.375rem, 0);
    transition:
      box-shadow 0.2s ease-in-out,
      transform 0.2s ease-in-out;
  }

  &:not(:hover) {
    transform: translate3d(0, 0, 0);
    transition:
      box-shadow 0.2s ease-in-out,
      transform 0.2s ease-in-out;
  }
`;

const Text = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1.313rem 1.25rem 1rem;

  h3,
  p {
    text-align: center;
  }

  h3 {
    font-size: 1.1rem;
  }

  p {
    color: var(--connolly-red);
    font-size: 0.875rem;
    margin-top: 0.1em;
    text-decoration: underline;
  }
`;

const ProductTitle = styled.h3`
  margin-bottom: 0.1rem;
`;

const PlaceholderImage = styled.div`
  align-items: center;
  background-color: #f5f5f5;
  border: 1px dashed #ccc;
  color: #666;
  display: flex;
  font-size: 0.875rem;
  height: 380px;
  justify-content: center;
  width: 100%;

  span {
    text-align: center;
  }
`;

export default Card;
